var map = {
	"./sticker-nye-darkfans-en.svg": "c9bb",
	"./sticker-nye-darkfans-es.svg": "dc20",
	"./sticker-nye-loverfans-en.svg": "9158",
	"./sticker-nye-loverfans-es.svg": "2e01",
	"./sticker-nye-scatbook-en.svg": "2edb",
	"./sticker-nye-scatbook-es.svg": "6af9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbcf";